import { loadable } from 'nordic/lazy';
import compatsWidgetSticky from './compats-widget-sticky';

const CompatsWidgetSticky = loadable(() =>
  import('../../../../components/compats-widget/sticky/compats-widget-sticky-container.mobile'),
);

export default compatsWidgetSticky(CompatsWidgetSticky);
